import React, { forwardRef } from 'react';
import "./inputSelect.css";

const InputSelect = forwardRef(({
  id,
  labelText,
  changeHandler,
  inputArr,
  defaultVal,
  disableVal,
  selectedValue,
}, ref) => {
  const optionElements = Object.values(inputArr).map((item) => (
    <option key={item.id ? item.id : item} value={item.id ? item.id : item}>
      {item.name ? item.name : item}
    </option>
  ));

  return (
    <div id={id + "Input"} className="form-input-class">
      <label className="form-label" htmlFor={"select-" + id + "Input"}>{labelText} </label>
      <div className="select-form-Input">
        <select
          className="form-control form-select"
          id={"select-" + id + "Input"}
          name={"select-" + id + "Input"}
          onChange={changeHandler}
          disabled={disableVal ? disableVal : false}
          value={selectedValue}
          ref={ref}
        >
          {!defaultVal && (
            <option key="Any" value="">
              - Any -
            </option>
          )}
          {optionElements}
        </select>
      </div>
    </div>
  );
});

export default InputSelect;
